module.exports = __webpack_public_path__ + "img/riseup_logo.b3ae3317.svg";